module.exports = __webpack_public_path__ + "img/不锈钢咖啡壶.7329b047.png";